
import { v4 as uuidv4 } from "uuid";
import { FeatureUserRating } from "@models";
import {
  CreatureLimitation,
  Summon, 
} from "@dndModels";
import { SIZE_TO_NUM_MAP } from "@dndModels/Constants";

export class SummonOption {
  true_id = "";
  summon_type: "Creature" | "Custom" | "Creature using Transform" = "Creature";
  count = 1;
  creature_limit: CreatureLimitation = new CreatureLimitation();
  custom_stat_block: Summon | null = null;
  transform_id = "";
  
  constructor(obj?: any, log_it = false) {
    this.true_id = obj ? obj.true_id : uuidv4().toString();
    if (obj) {
      this.summon_type = obj.summon_type ? obj.summon_type : (obj.custom ? "Custom" : "Creature");
      this.count = obj.count ? obj.count : 1;
      if (log_it) {
        debugger;
      }
      this.creature_limit = obj.creature_limit ? new CreatureLimitation(obj.creature_limit) : new CreatureLimitation();
      if (obj.specific && obj.specific_id && obj.specific_id !== "Any") {
        this.creature_limit.creature_ids = [obj.specific_id];
      }
      if (obj.creature_type && obj.creature_type !== "Any") {
        this.creature_limit.creature_types = [obj.creature_type];
      } else if (obj.type && obj.type !== "Any") {
        this.creature_limit.creature_types = [obj.type];
      }
      if (obj.subtype && obj.subtype !== "Any") {
        this.creature_limit.subtypes = [obj.subtype];
      } 
      if (obj.challenge_rating && obj.challenge_rating !== 0) {
        this.creature_limit.min_challenge_rating = obj.challenge_rating;
        this.creature_limit.max_challenge_rating = obj.challenge_rating;
      }
      if (obj.size && obj.size !== "Any") { // ["Any","Tiny","Small","Medium","Large","Huge","Gargantuan"]
        this.creature_limit.size_nums = [SIZE_TO_NUM_MAP[obj.size]];
      }
      if (!obj.flying) {
        this.creature_limit.allow_flight = false;
      }
      if (!obj.swimming) {
        this.creature_limit.allow_swimming = false;
      }
      this.custom_stat_block = obj.custom_stat_block ? new Summon(obj.custom_stat_block, log_it) : null;
      this.transform_id = obj.transform_id ? obj.transform_id : "";
      if (this.transform_id !== "") {
        debugger;
      }
      if (this.summon_type === "Creature" && this.custom_stat_block) {
        this.summon_type = "Custom";
      }
      if (log_it) {
        debugger;
      }
    }
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      summon_type: this.summon_type,
      count: this.count,
      creature_limit: this.creature_limit.toDBObj(),
      custom_stat_block: this.custom_stat_block ? this.custom_stat_block.toDBObj() : null,
      transform_id: this.transform_id
    };
  }

  clone(drop_ids = false): SummonOption {
    const new_obj = new SummonOption();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  copy(copyMe: SummonOption, drop_ids = false): void {
    if (!drop_ids) {
      this.true_id = copyMe.true_id;
    }
    this.summon_type = copyMe.summon_type;
    this.count = copyMe.count;
    this.custom_stat_block = copyMe.custom_stat_block ? copyMe.custom_stat_block.clone(drop_ids) : null;
    this.creature_limit = copyMe.creature_limit.clone();
    this.transform_id = copyMe.transform_id;
  }

  connectUserRatings(userRatings: FeatureUserRating[]) {
    if (this.custom_stat_block) {
      this.custom_stat_block.connectUserRatings(userRatings);
    }
  }
}